import 'core-js/stable'
import { createApp } from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue-pro'
import { iconsSet as icons } from './assets/icons/icons.js'
import { createPinia } from 'pinia'
import axios from './request/index'
import Toast, { useToast } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import moment from 'moment'
import VCalendar from 'v-calendar'
import 'v-calendar/dist/style.css'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import * as dateHelper from './helpers/dateHelper'
import numeral from 'numeral'
import { setupAuth } from './config/plugins'
import { setAuthInstance } from './router'
import { SUPPORTED_LANGUAGES } from './constants/languages'

import CInput from './components/compat/CInput.vue'
import CSelect from './components/compat/CSelect.vue'
import CInputCheckbox from './components/compat/CInputCheckbox.vue'
import CInputFile from './components/compat/CInputFile.vue'
import CDataTable from './components/compat/CDataTable.vue'
import CModal from './components/compat/CModal.vue'
import CMultiSelect from './components/compat/CMultiSelect.vue'
import CCardImg from './components/compat/CCardImg.vue'
import CTextarea from './components/compat/CTextarea.vue'
import CImg from './components/compat/CImg.vue'
import { CIcon } from '@coreui/icons-vue'
import { observeModalA11y } from './utils/modalA11y'
import vCTooltipFixed from './directives/vCTooltipFixed'

const app = createApp(App)
app.provide('icons', icons)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(CoreuiVue)
// CoreUI's v-c-tooltip leaves orphaned tooltips on screen when the target
// element unmounts while hovered (e.g. table action buttons). Replace it.
delete app._context.directives['c-tooltip']
app.directive('c-tooltip', vCTooltipFixed)
app.component('CInput', CInput)
app.component('CSelect', CSelect)
app.component('CInputCheckbox', CInputCheckbox)
app.component('CInputFile', CInputFile)
app.component('CDataTable', CDataTable)
delete app._context.components['CModal']
app.component('CModal', CModal)
delete app._context.components['CMultiSelect']
app.component('CMultiSelect', CMultiSelect)
app.component('CCardImg', CCardImg)
app.component('CTextarea', CTextarea)
app.component('CImg', CImg)
app.component('CIcon', CIcon)
app.use(VueTelInput)
app.use(Toast, {
  closeWith: ['click'],
  maxToasts: 5,
  newestOnTop: true,
})
app.config.globalProperties.$toast = useToast()
app.use(VCalendar, {
  componentPrefix: 'vc',
})

app.config.globalProperties.$languages = SUPPORTED_LANGUAGES.map(lang => ({
  label: lang.label,
  value: lang.value,
}))
app.config.globalProperties.$log = console.log.bind(console)
app.config.globalProperties.$http = axios
app.config.globalProperties.$moment = moment
app.config.globalProperties.$formatDate = dateHelper.formatDate
app.config.globalProperties.$formatDateTime = dateHelper.formatDateTime
app.config.globalProperties.$is24Hours = dateHelper.use24HourFormat

app.config.globalProperties.$filters = {
  numFormat(value) {
    return numeral(value).format('0,0.00')
  },
  toHMTime(value) {
    var minutes = Math.floor((value) / 60)
    var seconds = value - (minutes * 60)
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (seconds < 10) {
      seconds = '0' + seconds
    }
    return minutes + ':' + seconds
  },
}

const env = process.env.VUE_APP_ENV || 'PROD'
const colors = {
  LOCAL: '#c4dcff',
  PROD: '#F4F4FC',
  QA: '#c4dcff',
}
document.documentElement.style.setProperty('--bg-color', colors[env])

setupAuth(app, router, axios)
setAuthInstance(app.config.globalProperties.$auth)

observeModalA11y()

app.mount('#app')
